module.exports = __webpack_public_path__ + "static/img/xiadan.57d06241.png";